export function formatLensCount(lensCount: number) {
    return `${lensCount} ${lensCount === 1 ? "Lens" : "Lenses"}`;
}
